import { Field, FieldFooter } from '@busybusy/webapp-react-ui';
import { EquipmentModelType } from '__generated__/graphql';
import classNames from 'classnames';
import { ClassName } from 'types/ClassName';
import EquipmentModelPicker, { IExistingModel } from '../EquipmentModelPicker/EquipmentModelPicker';

interface IEquipmentModelFormFieldProps {
  className?: ClassName;
  form: any;
  equipmentCategoryId?: string;
  equipmentMakeId?: string;
  name: string;
  equipmentModelType?: EquipmentModelType;
  disabled?: boolean;
  onChange?: (value: string | null) => void;
  onNewModel?: (newModel: { id: string | null; name: string | null }) => void;
  onExistingModel?: (existingModel: IExistingModel) => void;
  validations?: any;
}

function EquipmentModelFormField(props: IEquipmentModelFormFieldProps) {
  const {
    form,
    name,
    equipmentCategoryId,
    equipmentMakeId,
    equipmentModelType,
    validations,
    className,
    onChange,
    onNewModel,
    onExistingModel,
    ...other
  } = props;

  const classes = classNames('equipment-model-picker-form-field', className);

  function renderField({ ...fieldProps }) {
    function handleOnSelect(val: string | null) {
      fieldProps.handleChange(val, onChange);
    }

    const handleOnNewModel = (selectedModel: { id: string | null; name: string | null }) => {
      onNewModel ? onNewModel(selectedModel) : null;
      handleOnSelect(selectedModel.id);
    };

    const handleOnExistingModel = (selectedModel: IExistingModel) => {
      onExistingModel ? onExistingModel(selectedModel) : null;
      handleOnSelect(selectedModel.id);
    };

    return (
      <>
        <EquipmentModelPicker
          error={fieldProps.hasError}
          value={form.state.data[name]}
          onSelect={handleOnSelect}
          onNewModel={handleOnNewModel}
          equipmentCategoryId={equipmentCategoryId}
          equipmentMakeId={equipmentMakeId}
          equipmentModelType={equipmentModelType}
          onExistingModel={handleOnExistingModel}
          {...other}
        />
        <FieldFooter errorMessage={fieldProps.errorMessage} hasError={fieldProps.hasError} />
      </>
    );
  }

  return <Field form={form} name={name} validations={validations} className={classes} render={renderField} />;
}

export default EquipmentModelFormField;
